import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import axios from "../../API/axios";
import CreatableSelect from "react-select/creatable";
import { debounce } from "lodash";
import { toast } from "react-hot-toast";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";

const options = [
  { value: "html", label: "HTML" },
  { value: "css", label: "CSS" },
  { value: "javascript", label: "JavaScript" },
  { value: "react", label: "React" },
];

const CCVSKill = ({ show, handleClose, getUserCcv, resumeId }) => {
  const sessionId = localStorage.getItem("sessionId");
  const { t } = useTranslation();

  //************************Industry Get Start  ************************//
  // const [selectedOption, setSelectedOption] = useState(null);
  // const [selectedSkill, setSelectedSkill] = useState("");
  // const [industryList, setIndustryList] = useState("");
  const [display, setDisplay] = useState(false);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  //************************Industry Get Start  ************************//
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState("");
  const [industryList, setIndustryList] = useState("");
  const [showIndustryInput, setShowIndustryInput] = useState(false);
  const [industryInputValue, setIndustryInputValue] = useState("");
  // console.log(selectedOption);
  const getIndustry = () => {
    axios
      .get(`Master/GetFirmIndustryTypeDDL?&LangKey=${language}`)
      .then((response) => {
        // console.log(response.data.responseData);
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.fitid,
          label: item.name,
        }));
        setIndustryList(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getIndustry();
  }, []);

  //************************Industry Get End  ************************//

  //************************Get Skill DDL Start  ************************//
  const [value, setValue] = useState(null);
  const [page, setPage] = useState(0);
  const [typed, setTyped] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [skillCheck, setSkillCheck] = useState(false);
  const [newCreateoption, setNewCreateoption] = useState("");
  const [options, setOptions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  // console.log('value', value);
  const logValue = debounce((typed) => {
    setTyped(typed);
  }, 250);
  // console.log('typed', typed);
  const addOptions = () => {
    setIsLoading(true);
    axios
      .get(
        `Master/GetSkillsByIndustryDDL?search=${typed}&Fitid=${selectedOption.value
        }&pageNumber=${page + 1}&pageSize=100&LangKey=${language}&DeviceType=Web`
      )
      .then((response) => {
        // console.log(response);
        const data = response.data.responseData.data.map((item) => ({
          value: item.skllId,
          label: item.name,
        }));
        setPage((prevPage) => prevPage + 1);
        setIsLoading(false);
        setOptions((prevOptions) => [...prevOptions, ...data]);
        setTotalPages(response.data.responseData.paging.totalPages);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleOpen = () => {
    setPage(1);
  };

  const handleChange = (value) => {
    setValue(value);
    setPage(0);
  };

  const handleInputChange = (typed) => {
    logValue(typed);
    if (!typed) setPage(0);
  };

  const handleMenuScrollToBottom = () => {
    if (page < totalPages) {
      addOptions();
    }
  };

  const renderOption = ({
    focusedOption,
    focusOption,
    key,
    labelKey,
    option,
    selectValue,
    style,
    valueArray,
  }) => {
    // Your rendering logic here
  };

  useEffect(() => {
    if (typed) {
      addOptions();
    }
  }, [typed]);

  //************************ Get Skill DDL End  ************************//

  //******** Add Skill Start  ********//
  const AddSkill = async () => {
    setDisplay(true);
    console.log(skillCheck, newCreateoption);
    // if (skillCheck === true) {

    if (selectedOption === null || value === null) {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
    } else {
      try {
        const postdatadetails = {
          deviceType: "Web",
          sessionId: sessionId,
          fitid: selectedOption.value,
          skillName: value.label,
          // skllId: value.value,
          rsmId: resumeId,
          langKey: language === "en" ? "" : language,
        };
        console.log(postdatadetails);
        await axios
          .post("ResumeData/AddRsmSkill", postdatadetails)
          .then((resData) => {
            // console.log('resData', resData);
            // toast.success(resData.data.message);
            setToastMessage(resData.data.message);
            setShowToast(true);
            // getUserSkill();
            handleClose();
            setSelectedOption("");
            setSelectedSkill("");
            setValue(null);
            setTyped("");
            setOptions([]);
            setPage(0);
            setTotalPages(0);
            setShowIndustryInput(false);
            setIndustryInputValue("");
            getUserCcv()
          });
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(error.response.data.message);
          setShowErrorToast(true);
        }
      }
    }
    // } else {

    //   if (value === null) {
    //     setWarningToastMessage(t("modals.Please fill all the required fields"));
    //     setShowWarningToast(true);
    //   } else {
    //     try {
    //       const postdatadetails = {
    //         deviceType: "Web",
    //         sessionId,
    //         skllId: value.value,
    //         rsmId: resumeId
    //       };
    //       console.log("postdatadetails", postdatadetails);
    //       await axios
    //         .post("ResumeData/LinkRsmSkill", postdatadetails)
    //         .then((resData) => {
    //           // console.log('resData', resData);
    //           // toast.success(resData.data.message);
    //           setToastMessage(resData.data.message);
    //           setShowToast(true);
    //           // getUserSkill();
    //           handleClose();
    //           setSelectedOption("");
    //           setSelectedSkill("");
    //           setValue(null);
    //           setTyped("");
    //           setOptions([]);
    //           setPage(0);
    //           setTotalPages(0);
    //           getUserCcv()
    //         });
    //     } catch (error) {
    //       if (error.response && error.response.status === 404) {
    //         setWarningToastMessage(error.response.data.message);
    //         setShowWarningToast(true);
    //       } else {
    //         setErrorToastMessage(error.response.data.message);
    //         setShowErrorToast(true);
    //       }
    //     }
    //   }
    // }
  };
  //******** Add Skill End  ********//

  const handleCreateOption = (newOption) => {
    setSkillCheck(true);
    setNewCreateoption(newOption);

    const newOptionObject = {
      label: newOption,
      value: newOption.toLowerCase().replace(/\W/g, ""),
    };

    // Set the newly created option as the selected value
    setValue(newOptionObject);
  };


  // useEffect(() => {
  //   if (show) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [show]);
  return (
    <>

      {show && (
        <div
          className="modal fade show postAdd"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="modal-dialog  modal-dialog-centered" role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>{t("Manage Job.Add Skills")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>
              <div className=" pb-4 settings p-2">
                <div className="mb-4">
                  <label htmlFor="about">
                       {t ("User Profile.Industry")}    
                      <span className='text-danger ms-2'>*</span></label>
                  {showIndustryInput ? (
                    <input
                      type="text"
                      className="Dark-Input-from-group form-control"
                      value={industryInputValue}
                      onChange={(e) => {
                        setIndustryInputValue(e.target.value);
                        setSelectedOption({ ...selectedOption, label: e.target.value });
                      }}
                      onBlur={() => {
                        if (!industryInputValue.trim()) {
                          setShowIndustryInput(false);
                        }
                      }}
                      autoFocus
                    />
                  ) : (
                    <Select
                      value={selectedOption}
                      onChange={(option) => {
                        setSelectedOption(option);
                        if (option) {
                          setIndustryInputValue(option.label);
                          setShowIndustryInput(true);
                        }
                      }}
                      options={industryList}
                      placeholder={t("User Profile.Select industry")}
                      invalid={display && selectedOption === ""}
                      className="dropdownBorder"
                      styles={customStyles}
                    />
                  )}
                  {display && !selectedOption ? (
                    <span className="error_msg_lbl">
                      {t("User Profile.Please Select industry")}{" "}
                    </span>
                  ) : null}
                </div>
                <div>
                   <label htmlFor="about">
                       {t ("User Profile.Skills")}    
                      <span className='text-danger ms-2'>*</span></label>
                  <CreatableSelect
                    value={value}
                    options={options}
                    optionRenderer={renderOption}
                    onOpen={handleOpen}
                    onChange={handleChange}
                    onMenuScrollToBottom={handleMenuScrollToBottom}
                    onInputChange={handleInputChange}
                    isClearable

                    // onCreateOption={handleCreateOption}
                    placeholder={t("modals.Select Skill")}
                    invalid={display && value === ""}
                    styles={customStyles}
                    className="dropdownBorder"
                  />
                  {display && !value ? (
                    <span className="error_msg_lbl">{t("User Profile.Please Select Skill")} </span>
                  ) : null}
                </div>
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="closebtn me-2"
                  onClick={handleClose}
                  style={{ width: "70px" }}
                >
                   {t("User Profile.Close")}
                </button>
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={AddSkill}
                  style={{ width: "107px" }}

                >
                  {t("User Profile.Submit")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CCVSKill;
